var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadBuildIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 23V28.585L25.3284 26.7574L26.7426 28.1716L22.5 32.4142L18.2574 28.1716L19.6716 26.7574L21.5 28.585V23H23.5ZM22.5 12C26.0934 12 29.0544 14.7076 29.4541 18.1939C31.7858 18.8315 33.5 20.9656 33.5 23.5C33.5 26.3688 31.3036 28.7246 28.5006 28.9776L28.5 27C28.5 23.6863 25.8137 21 22.5 21C19.2616 21 16.6224 23.5656 16.5041 26.7751L16.5 27L16.5004 28.9776C13.697 28.7252 11.5 26.3692 11.5 23.5C11.5 20.9656 13.2142 18.8315 15.5465 18.1941C15.9456 14.7076 18.9066 12 22.5 12Z",
    fill: "#7a7a7a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBuildIcon);
export default __webpack_public_path__ + "static/media/uploadBuildIcon.5e864a8b.svg";
export { ForwardRef as ReactComponent };